import styled from 'styled-components'

export const ReplySectionContainer = styled.div`
    border-left: 4px solid rgba(32, 32, 32, 0.1);
    margin-left: 20px;
    margin-top: 25px;
`
export const BottomSeparator = styled.div`
    padding-left: 27px;
    hr {
        border-top: 1px solid rgba(32, 32, 32, 0.1);
    }
`
